import { render, staticRenderFns } from "./Vunerabilidade.vue?vue&type=template&id=7cdad453"
import script from "./Vunerabilidade.vue?vue&type=script&lang=js"
export * from "./Vunerabilidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports